import React, { useContext } from "react";

import {
  ListItem,
  ListItemText,
  Skeleton,
  Typography,
  useTheme,
} from "@mui/material";

import ProjectListButton from "components/styled/ProjectListButton";
import useTruncateString from "hooks/useTruncateString";
import { UserContext } from "utils/UserContext";

import PropTypes from "prop-types";

function GeneratedAlbum(props) {
  const { id, img, name, mainArtist, album } = props;

  const { albumsLoading, selectedAlbum, setSelectedAlbum } =
    useContext(UserContext);

  const mainTheme = useTheme();
  const handleTruncatedString = useTruncateString();

  return (
    <ListItem
      sx={{
        borderRadius: "1.25rem",
        padding: "3px",
      }}
    >
      <ProjectListButton
        sx={{
          bgcolor:
            selectedAlbum.id === id
              ? mainTheme.palette.darkBluePrimary.main
              : mainTheme.palette.blackPrimary.main,
          minWidth: albumsLoading && 300,
          margin: "5px 5px",
          borderRadius: "1.25rem",
        }}
        onClick={() => {
          setSelectedAlbum((prevInfo) => ({
            ...prevInfo,
            ...album,
          }));
        }}
      >
        {albumsLoading ? (
          <Skeleton variant="rectangular" width="6.5rem" height="6.5rem" />
        ) : (
          <img
            src={img}
            alt={name}
            style={{
              width: "6.5rem",
              height: "6.5rem",
            }}
          />
        )}
        <ListItemText
          sx={{
            margin: "0.5rem",
          }}
          primary={
            albumsLoading ? (
              <Typography variant="h6">
                <Skeleton />
              </Typography>
            ) : (
              handleTruncatedString({
                customText: name,
                customVariant: "body1",
                customComponent: "span",
                customSx: {
                  fontWeight: 600,
                  display: "block",
                  color: mainTheme.palette.whitePrimary.main,
                },
                maxCharacters: {
                  sm: 40,
                  smToMd: 44,
                  aboveMd: 63,
                },
              })
            )
          }
          secondary={
            albumsLoading ? (
              <Typography variant="body2">
                <Skeleton />
              </Typography>
            ) : (
              handleTruncatedString({
                customText: mainArtist,
                customVariant: "body1",
                customComponent: "span",
                customSx: {
                  display: "inline",
                  color: mainTheme.palette.whitePrimary.main,
                },
                maxCharacters: {
                  sm: 40,
                  smToMd: 44,
                  aboveMd: 63,
                },
              })
            )
          }
        />
      </ProjectListButton>
    </ListItem>
  );
}

GeneratedAlbum.propTypes = {
  id: PropTypes.string.isRequired,
  img: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  mainArtist: PropTypes.string.isRequired,
  album: PropTypes.shape({
    id: PropTypes.string.isRequired, // Example field in album
    name: PropTypes.string.isRequired, // Example field in album
    artists: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
      })
    ).isRequired, // Example of nested structure for artists
    images: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string.isRequired,
      })
    ).isRequired,
    external_urls: PropTypes.shape({
      spotify: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default GeneratedAlbum;
